// extracted by mini-css-extract-plugin
export default {"Html":"Html16n5qrcOfn4D","HtmlToolbar":"HtmlToolbarzoq_cE01ExYT","HtmlToolbar-Tab":"HtmlToolbar-Tab33v6_rPsJdqI","HtmlToolbar-Note":"HtmlToolbar-NotestpLTzstg_gZ"};